export function cadastroTerminalInRequest(params = {}) {
  return {
    type: '@cadastroterminal/CADASTROTERMINAL_IN_REQUEST',
    payload: { params },
  };
}

export function findCadastroTerminal(id) {
  return {
    type: '@cadastroterminal/FIND_CADASTROTERMINAL',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@cadastroterminal/FAILED_REQUEST',
  };
}

export function deleteCadastroTerminal(id , params) {
  return {
    type: '@cadastroterminal/DELETE_CADASTROTERMINAL',
    payload: { id , params },
  };
}

export function updateCadastroTerminal(cadastroterminal, params) {
  return {
    type: '@cadastroterminal/UPDATE_CADASTROTERMINAL',
    payload: { cadastroterminal, params },
  };
}

export function storeCadastroTerminal(cadastroterminal, params) {
  return {
    type: '@cadastroterminal/STORE_CADASTROTERMINAL',
    payload: { cadastroterminal, params },
  };
}

export function successInRequest(
  cadastroterminal,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@cadastroterminal/SUCCESS_IN_REQUEST',
    payload: { cadastroterminal, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(cadastroterminal) {
  return {
    type: '@cadastroterminal/SUCCESS_REQUEST',
    payload: { cadastroterminal },
  };
}

export function successRemove(params) {
  return {
    type: '@cadastroterminal/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cadastroterminal/RECORD_FILTERING',
    payload: { params },
  };
}
